import { useAuthContext } from '@/context/AuthContext';
import { useUserProfile } from '@/hooks';
import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { DISCLAIMS_REGISTRY } from '../config';

export function useActiveDisclaimer() {
  const { pathname, search } = useLocation();
  const { userInfo } = useAuthContext();
  const user = useUserProfile();

  const section = useMemo(() => new URLSearchParams(search).get('section'), [search]);

  return useMemo(() => {
    if (!userInfo || !user?.registrationDone) return null;

    const rule = DISCLAIMS_REGISTRY.find(
      registry =>
        matchPath({ path: registry.path, end: false }, pathname) &&
        (registry.section ? registry.section === section : true),
    );

    if (!rule) return null;

    const userCountry = userInfo.countries.find(country => !!rule.components[country]);
    return userCountry ? rule.components[userCountry] : null;
  }, [pathname, section, userInfo, user]);
}
